export const GET_DATA_MODULES_HOME = 'GET_DATA_MODULES_HOME'
export const REGISTER_USERS_CONNECTED_MODULES_HOME = 'REGISTER_USERS_CONNECTED_MODULES_HOME'
export const MENU_HOME_CATEGORY = 'MENU_HOME_CATEGORY'
